<main class="inscription-lieu-examen-page">
  <m-spinner
    v-if="isDossierEtudiantLoadingStateActive"
    :title="true"
    :description="true"
    :processing="true"
    :title-message=" $i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.loading_overlay.title')"
    :description-message=" $i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.loading_overlay.description')"
  />
  <template v-if="inscriptionLieuExamenInformations">
    <div class="inscription-lieu-examen-page__header">
      <div class="inscription-lieu-examen-page__header--mon-portail">
        <m-button
          icon-name="m-svg__arrow-return"
          @click="onRedirectToMonPortailButtonClick"
        >
          {{ $i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.mon_portail.button') }}
        </m-button>
      </div>
      <div class="inscription-lieu-examen-page__header--selecteur-session">
        <session-select />
      </div>
    </div>
  </template>
  <template v-if="dossierEtudiant">
    <section class="inscription-lieu-examen-page__dossier-etudiant">
      <div>
        <h5 class="inscription-lieu-examen-page__dossier-etudiant--title">
          {{ $i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.dossier_etudiant.title') }}
        </h5>
        <m-panel class="inscription-lieu-examen-page__dossier-etudiant--panel">
          <div>
            <m-icon
              name="m-svg__profile"
              size="50px"
            />
          </div>
          <div>
            <p>
              <strong>
                {{ $i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.dossier_etudiant.nom', dossierEtudiant.etudiant) }}
              </strong>
            </p>
            <p>
              {{ $i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.dossier_etudiant.nie', dossierEtudiant.etudiant) }}
            </p>
          </div>
        </m-panel>
        <template v-if="dossierEtudiant.horodateDerniereModification">
          <p class="inscription-lieu-examen-page__dossier-etudiant--last-update">
            {{ $i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.dossier_etudiant.updated_at', dossierEtudiant) }}
          </p>
        </template>
      </div>
      <template v-if="dossierEtudiant.gestionFicheRepondantDisponible">
        <m-button @click="onDisplayGestionFicheRepondantButtonClick">
          {{ $i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.dossier_etudiant.button_fiche_repondant_gestion') }}
        </m-button>
      </template>
    </section>
    <template v-if="messageImportantGlobal">
      <m-message
        class="inscription-lieu-examen-page__dossier-etudiant--message-important"
        :state="MMessageState.Error"
      >
        <span v-html="messageImportantGlobal" />
      </m-message>
    </template>
    <section class="inscription-lieu-examen-page__accordeon-informations">
      <m-accordion-group>
        <template v-if="dossierEtudiant.afficherMessageMaterielPermis">
          <m-accordion>
            <span slot="header">
              {{ $i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.informations_accordeon.materiel.title') }}
            </span>
            <p v-html="$i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.informations_accordeon.materiel.content.description')" />
          </m-accordion>
        </template>
        <template v-if="dossierEtudiant.afficherMessageCarteIdentite">
          <m-accordion>
            <span slot="header">
              {{ $i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.informations_accordeon.carte_identite.title') }}
            </span>
            <p v-html="$i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.informations_accordeon.carte_identite.content.description')" />
          </m-accordion>
        </template>
        <m-accordion>
          <span slot="header">
            {{ $i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.informations_accordeon.accommodements.title') }}
          </span>
          <p v-html="$i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.informations_accordeon.accommodements.content.description')" />
          <ul>
            <template v-for="message in $i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.informations_accordeon.accommodements.content.options', { returnObjects: true })">
              <li v-html="message" />
            </template>
          </ul>
        </m-accordion>
      </m-accordion-group>
    </section>
  </template>
  <template v-if="inscriptionLieuExamenInformations || dossierEtudiant">
    <section class="inscription-lieu-examen-page__informations-inscription">
      <h3 class="inscription-lieu-examen-page__informations-inscription--title">
        {{ $i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.informations_inscription.title', dossierEtudiant ? dossierEtudiant.session : inscriptionLieuExamenInformations.session) }}
      </h3>
      <p
        class="inscription-lieu-examen-page__informations-inscription--registration-deadline"
        v-html="$i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.informations_inscription.registration_deadline', dossierEtudiant ? dossierEtudiant.session : inscriptionLieuExamenInformations.session)"
      />
      <m-accordion-group
        class="inscription-lieu-examen-page__informations-inscription--accordion"
        :concurrent="true"
      >
        <m-accordion :open="true">
          <span slot="header">
            {{ $i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.informations_inscription.message.title') }}
          </span>
          <p v-html="$i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.informations_inscription.message.liste.title')" />
          <ul>
            <template v-for="message in $i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.informations_inscription.message.liste.options', { returnObjects: true })">
              <li v-html="message" />
            </template>
          </ul>
          <p v-html="$i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.informations_inscription.message.situation.title')" />
          <ul>
            <li v-html="$i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.informations_inscription.message.situation.options.situation_a.message')" />
            <li v-html="$i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.informations_inscription.message.situation.options.situation_b.message')" />
            <li>
              <span v-html="$i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.informations_inscription.message.situation.options.situation_c.message')" />
              <ul>
                <li v-html="$i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.informations_inscription.message.situation.options.situation_c.note')" />
              </ul>
            </li>
          </ul>
        </m-accordion>
      </m-accordion-group>
    </section>
  </template>
  <transition
    name="fade-fast"
    mode="out-in"
  >
    <router-view :key="$route.params.token" />
  </transition>
  <template v-if="dossierEtudiant">
    <template v-if="dossierEtudiant.afficherMessageContact">
      <section class="inscription-lieu-examen-page__dossier-etudiant--soutien">
        <m-message :state="MMessageState.Information">
          <p v-html="$i18next.t('modules.inscription-lieu-examen.InscriptionLieuExamenPage.content.dossier_etudiant.informations_soutien', dossierEtudiant)" />
        </m-message>
      </section>
    </template>
  </template>
</main>